import { c as _c } from "react/compiler-runtime";
import { getSitePreset } from '@module/apis/client-side/preset';
import type { IPresetResponse } from '@module/apis/client-side/preset/type';
import { presetQueryKeys } from '@module/queries/preset/presetQueryKeys';
import type { CustomUseQueryOptions } from '@module/queries/type';
import { normalizeHostname } from '@module/utils/site/hostname';
import useIsMounted from '@module/utils/useIsMounted';
import { useQuery } from '@tanstack/react-query';
export const useFetchGetSitePresetQuery = options => {
  const $ = _c(7);
  let currentSiteInfo;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    currentSiteInfo = {
      host: typeof window !== "undefined" ? normalizeHostname(window.location.hostname) : "pandalive.co.kr"
    };
    t1 = useQuery;
    t0 = presetQueryKeys.fetchPreset(currentSiteInfo.host);
    $[0] = currentSiteInfo;
    $[1] = t0;
    $[2] = t1;
  } else {
    currentSiteInfo = $[0];
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = t0.queryKey;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => getSitePreset({
      hostname: currentSiteInfo.host
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = useIsMounted();
  let t5;
  if ($[4] !== options || $[5] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      ...options,
      staleTime: Infinity,
      enabled: t4,
      retry: false
    };
    $[4] = options;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t1(t5);
};